import React, { useState, useMemo } from 'react';
import { TransactionDrawer } from './TransactionDrawer';
import { TransactionListCard } from './TransactionListCard';
import { Transaction } from 'features/misc';

export const TransactionsList = ({ transactions, status = 'n/a' }) => {
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const handleRowClick = (transaction) => {
    setSelectedTransaction(transaction);
    setIsDrawerOpen(true);
  };

  const flattenedTransactions = useMemo(() => {
    if (status === 'all' && Array.isArray(transactions?.transactions)) {
      const all = [];

      transactions.transactions.forEach((entry) => {
        const txStatusGroups = entry.transactions;

        if (txStatusGroups && typeof txStatusGroups === 'object') {
          Object.values(txStatusGroups).forEach((txArray) => {
            if (Array.isArray(txArray)) {
              all.push(...txArray);
            }
          });
        }
      });

      return all;
    }

    // Default behavior if status !== 'all'
    return Array.isArray(transactions?.transactions)
      ? transactions.transactions
      : [];
  }, [transactions, status]);

  return (
    <div className=''>
      {flattenedTransactions.length > 0 ? (
        <div className="pb-3">
          {flattenedTransactions.map((transaction) => (
            <Transaction
              key={transaction.id}
              transaction={transaction}
              // onClick={() => handleRowClick(transaction)}
            />
          ))}
        </div>
      ) : (
        <div className="flex flex-col items-center justify-center h-full py-12">
          <div className="text-lg font-bold text-gray-300 dark:text-gray-600">
            No transactions to display at the moment.
          </div>
        </div>
      )}

      <TransactionDrawer
        isOpen={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
        transaction={selectedTransaction}
      />
    </div>
  );
};
